<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="paste"></table-header>
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          align="center"
          :data="tableData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearTableV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="addDate" title="日期" width="120">
          <template v-slot="{ row }">
            <vxe-input v-model="row.addDate" placeholder="选择日期" type="date" transfer></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" width="180">
          <template v-slot:header>
            <span style="color: red">*</span>所属公司
          </template>
          <template v-slot="{ row }">
            <platform-corp :row="row" :field="'compName'" :placeholder="'请选择所属公司'"></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bankName" title="开户行" width="200">
          <template v-slot:header>
            <span style="color: red">*</span>开户行
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.bankName" placeholder="请输入开户行"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bankAccount" title="银行账号" width="200">
          <template v-slot:header>
            <span style="color: red">*</span>银行账号
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.bankAccount" placeholder="请输入银行账号"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="clientName" title="客户名称" width="150">
          <template v-slot="scope">
            <div class="link-text" @click="openChooseAccount(scope.row, 'clientName')">
              {{ scope.row.clientName ? scope.row.clientName : "选择客户" }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="摘要" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.note" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="debiteAmount" title="借方" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.debiteAmount" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="creditAmount" title="贷方" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.creditAmount" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent">上传导入文件</Button>
      <Button status="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember title="选择客户">
      <account @choose="chooseAccountEvent" ref="chooseAccount"></account>
    </vxe-modal>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from '@/apiProvider';
  import XLSX from "xlsx";
  import Message from "@/components/common/Message";
  import {getExcelTime, showLoading, hideLoading} from '@/utils/util';
  import TableHeader from "../../components/common/TableHeader";
  import md5 from "js-md5";
  import PlatformCorp from "@/components/common/PlatformCorp";
  import Account from '@/components/modal/Account'

  export default {
    components: {Message, TableHeader, PlatformCorp, Account},
    data() {
      return {
        isShowChooseAccount: false,
        tableData: [{
          no: 1,
          addDate: null,
          bankAccount: null,
          bankName: null,
          clientName: null,
          compName: null,
          creditAmount: null,
          debiteAmount: null,
          note: null,
        }],
        tableRules: {
          addDate: [{required: true, message: "请选择日期"}],
          bankAccount: [{required: true, message: "请输入银行账号"}],
          bankName: [{required: true, message: "请输入开户行"}],
          compName: [{required: true, message: "请选择所属公司"}],
        },
        messageVisible: false,
        message: '',
        records: [],
        fileName: '',
      }
    },
    mounted() {

    },
    methods: {
      openChooseAccount(row, field) {
        this.isShowChooseAccount = true;
        this.currentRow = row;
        this.currentChooseColumn = field;
        this.$refs.chooseAccount.init();
      },
      chooseAccountEvent(account, type) {
        this.currentRow[this.currentChooseColumn] = account.userName;
        this.isShowChooseAccount = false;
        this.$refs.xTable.clearValidate(this.currentChooseColumn);
      },
      impotEvent() {
        let self = this;
        this.$refs.xTable.readFile({
          types: ['xls', 'xlsx']
        }).then(evnt => {
          showLoading();
          const tableData = [];
          const files = evnt.target.files;
          const fileReader = new FileReader();
          this.fileName = files[0].name;
          fileReader.onload = (ev) => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {type: 'binary'});
            const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
            // 解析数据
            let xlsxData = csvData.split('\n');
            //删除xlsx列名
            xlsxData.splice(0, 1);
            xlsxData.forEach((vRow) => {
              if (vRow) {
                const vCols = vRow.split(',');
                let account = vCols[3].split('_');
                const item = {
                  no: vCols[0],
                  addDate: getExcelTime(vCols[1]),
                  compName: vCols[2],
                  bankName: account[0],
                  bankAccount: account[1],
                  clientName: vCols[4],
                  note: vCols[5],
                  debiteAmount: vCols[6],
                  creditAmount: vCols[7],
                };
                tableData.push(item);
              }
            })
            this.tableData = tableData;
          }
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            hideLoading();
          }, 1000);
        })
      },
      async insertEvent() {
        let record = {
          no: this.$refs.xTable.data.length + 1,
          addDate: null,
          bankAccount: null,
          bankName: null,
          clientName: null,
          compName: null,
          creditAmount: null,
          debiteAmount: null,
          note: null,
        };
        this.pushIntoTable(record);
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      paste() {
        let records = this.records.sort((a, b) => a.no - b.no);
        if (records.length > 0) {
          records.map(i => {
            let record = Object.assign({}, i)
            record.no = this.$refs.xTable.data.length + 1;
            this.pushIntoTable(record);
          })
        } else {
          this.$XModal.message({status: "error", message: "请选择需要复制的信息！"});
        }
      },
      pushIntoTable(record) {
        let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
        this.$refs.xTable.data.push(record);
        this.$refs.xTable.setActiveCell(newRow, "userName");
      },
      async validEvent() {
        let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
        return errMap ? false : true
      },
      removeEvent() {
        let records = this.records;
        if (records.length > 0) {
          if (this.$refs.xTable.tableData.length > 1) {
            this.$XModal.confirm("您确定要删除选中数据?").then((type) => {
              if (type === "confirm") {
                this.clearTableV()
                records.map(i => {
                  this.$refs.xTable.remove(i);
                  let key = this.$refs.xTable.data.indexOf(i);
                  this.$refs.xTable.data.splice(key, 1);
                })
                this.records = [];
                if (this.isExport === false) {
                  this.$refs.xTable.data.map((j, index) => {
                    j.no = index + 1;
                  })
                }
              }
            });
          } else {
            this.$XModal.alert({
              message: "已经是最后一条了！",
              status: "warning",
            });
          }
        } else {
          this.$XModal.message({status: "error", message: "请选择需要删除的信息！"});
        }
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
      },
      async commit() {
        let sts = await this.validEvent()
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return
        }
        this.save();
      },
      async save() {
        showLoading();
        let arr = JSON.parse(JSON.stringify(this.tableData));
        arr.map(i => {
          i.addDate = this.$utils.timestamp(i.addDate);
        })
        let res = await $api.twoReport.post('importBankAccount', {
          bankAccountList: arr,
          fileName: this.fileName
        });
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('提交成功');
          this.close();
          this.$emit('afterSave');
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + '序号' + (this.tableData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
            })
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      closeMessage() {
        this.messageVisible = false;
      },
      close() {
        this.tableData = [{
          no: 1,
          addDate: null,
          bankAccount: null,
          bankName: null,
          clientName: null,
          compName: null,
          creditAmount: null,
          debiteAmount: null,
          note: null,
        }];
      }
    }
  }
</script>

<style scoped>

</style>